export const RemoveModalContent = {
  document: {
    title: 'Are you sure you want to remove your draft?',
    getDescription: (title: string) => `You are about to remove your draft changes for ${title}, do you want to continue?`,
  },
  product: {
    title: 'Are you sure you want to remove your draft?',
    getDescription: (title: string) => `You are about to remove your draft changes for ${title}, do you want to continue?`,
  },
  lastProduct: {
    title: 'Unable to remove product',
    getDescription: () => 'You cannot delete the last product in a submission. If you would like to remove the last product association, please cancel the submission and retire the document.',
  },
};
